import React from 'react';
import { graphql } from 'gatsby';
import isNil from 'utils/isNil';
import WebsiteLayout from 'layouts/websiteLayout';
import PartnersHeroSection from 'components/Page/Partners/PartnersHeroSection';
import PartnersFeatureSection from 'components/Page/Partners/PartnersFeatureSection';
import SEO, { createSEO } from 'components/Core/SEO';
import useGlobalHeader from 'hooks/useGlobalHeader';
import useGlobalFooter from 'hooks/useGlobalFooter';

const PartnersPage = props => {
  const pageImages = props.data.allContentfulImage;
  let backImg;
  let img1;
  let img2;
  pageImages.edges.forEach(imageItem => {
    if (imageItem.node.internalName === 'bg-partners-01') {
      backImg = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Product Visualization - Marketplace') {
      img1 = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'Partners') {
      img2 = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    }
  });
  const header = useGlobalHeader();
  const footer = useGlobalFooter();
  const image = {
    file: {
      url: backImg,
    },
  };

  const wistiaVideo = 'https://servicetitan-1.wistia.com/medias/ls5azfv993';

  const image1 = {
    file: { url: img1 },
  };
  const features1 = [
    {
      iconType: 'icon-find-person',
      title: 'Find the right partners',
      description:
        'Browse a major list of approved partners and see the value and benefits they bring.',
    },
    {
      iconType: 'icon-signup',
      title: 'Sign up with partners',
      description:
        'Get details on how to sign up with a partner and launch an integration through dedicated partner pages.',
    },
    {
      iconType: 'icon-grow-business',
      title: 'Grow your business',
      description:
        'Apply integrations and services your operations and share data to benefit your business.',
    },
  ];

  const image2 = {
    file: { url: img2 },
  };
  const features2 = [
    {
      iconType: 'icon-cloud-platform',
      title: "Build on ServiceTitan's cloud platform",
      description:
        'Integrate directly into ServiceTitan via APIs to enhance processes and share data.',
    },
    {
      iconType: 'icon-expand-customer',
      title: 'Expand your customer base',
      description:
        'List on the #1 home services marketplace and showcase the value of your product and services to ServiceTitan customers.',
    },
    {
      iconType: 'icon-make-happy',
      title: 'Make existing customers happy',
      description:
        'Provide your existing customers with an experience of your product that is fully integrated into a home services management platform.',
    },
  ];

  const seo = createSEO(props.data.contentfulSeo, props);

  return (
    <WebsiteLayout header={header} footer={footer} hero={{ backgroundImage: { image } }}>
      <SEO {...seo} />
      <PartnersHeroSection
        backgroundImg={image}
        title="The platform for the home services industry."
        video={wistiaVideo}
      />
      <PartnersFeatureSection
        background="#F5FCFF"
        subTitle="FOR the service providers"
        title="Find the best services and integrations to grow your business."
        description="ServiceTitan Marketplace connects you with innovative products and value-added services to help increase your team's productivity and improve the customer experience. Simply select the best partners for your company and unlock the potential of your business."
        sideImage={image1}
        buttonTitle="Find a Partner"
        buttonType="secondary"
        features={features1}
        link="https://marketplace.servicetitan.com"
        reversed={false}
      />
      <PartnersFeatureSection
        background="#FFF"
        subTitle="FOR the partners"
        title="Lead the next phase of innovation for home services."
        description="ServiceTitan Marketplace allows you to package and offer your products and services to the world's best residential contractors. Develop robust business solutions and add value to the home services industry."
        sideImage={image2}
        buttonTitle="Become a Partner"
        buttonType="secondary"
        features={features2}
        link="https://developer.servicetitan.com"
        reversed
      />
    </WebsiteLayout>
  );
};

export default PartnersPage;

export const PartnersPageQuery = graphql`
  query PartnersPageQuery {
    contentfulSeo(internalName: { eq: "Partners" }) {
      ...Seo
    }
    allContentfulImage(
      filter: {
        contentful_id: {
          in: [
            "6LcugNjdBi4tx9PWGqxPfz" #bg-partners-01
            "2enL50yJDm7XsHCB2W033U" #Product Visualization - Marketplace
            "6lS9umacJbZuLziahOqskf" #Partners
          ]
        }
      }
    ) {
      edges {
        node {
          internalName
          image {
            fluid(quality: 100) {
              ...GatsbyContentfulFluid_withWebp_noBase64
            }
          }
        }
      }
    }
  }
`;
